import { TIcon } from 'interfaces/TIcon';

export const Revert = ({ className }: TIcon) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`fill-current ${className}`}
    >
      <g clipPath="url(#clip0_11872_11254)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.869 9.00801C18.351 8.16887 16.6015 7.84579 14.884 8.08744C13.1665 8.32908 11.5739 9.12238 10.3465 10.3478C10.3393 10.3549 10.3321 10.3619 10.3247 10.3688L7.52457 13H11C11.5523 13 12 13.4477 12 14C12 14.5523 11.5523 15 11 15H5.01144C4.89816 15.0013 4.78483 14.9834 4.67668 14.9466C4.52691 14.8956 4.38709 14.8082 4.2712 14.6848C4.15301 14.5591 4.07368 14.4108 4.03275 14.2548C4.02317 14.2183 4.0157 14.1814 4.01032 14.1443C4.00291 14.0931 3.99947 14.0415 4 13.99V8C4 7.44772 4.44771 7 5 7C5.55228 7 6 7.44772 6 8V11.6882L8.94444 8.92141C10.4773 7.39587 12.4636 6.40828 14.6053 6.10695C16.7522 5.80488 18.9392 6.20874 20.8366 7.25766C22.734 8.30658 24.2392 9.94375 25.1252 11.9225C26.0113 13.9012 26.2303 16.1143 25.7492 18.2284C25.2682 20.3423 24.1131 22.2428 22.458 23.6432C20.803 25.0437 18.7376 25.8684 16.5731 25.9929C14.4087 26.1175 12.2623 25.5352 10.4575 24.3339C8.65265 23.1326 7.28721 21.3772 6.56677 19.3324C6.38325 18.8115 6.65675 18.2404 7.17766 18.0569C7.69856 17.8734 8.26961 18.1469 8.45313 18.6678C9.02949 20.3037 10.1218 21.7079 11.5657 22.669C13.0095 23.6301 14.7266 24.0959 16.4582 23.9962C18.1898 23.8966 19.8421 23.2368 21.1661 22.1165C22.4902 20.9961 23.4142 19.4758 23.7991 17.7846C24.184 16.0934 24.0088 14.3229 23.2999 12.7399C22.591 11.1569 21.3869 9.84714 19.869 9.00801Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_11872_11254">
          <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 28 4)" />
        </clipPath>
      </defs>
    </svg>
  );
};
